import styled from "styled-components/macro";

export const StyledDiagnosticTestGroupsPage = styled.div`
  width: 100%;
`;
